import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function CellarBanner() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.08, 1.16]);

  return (
    <section
      ref={ref}
      data-testid="cellar-banner"
      aria-label="A great spirit is not just a drink"
      className="relative w-full overflow-hidden"
      style={{ height: "clamp(240px, 34vh, 420px)" }}
    >
      {/* Parallax image */}
      <motion.img
        src="/banner/cellar-banner.jpg"
        alt="A whiskey glass glowing under a shaft of light in an aged oak barrel cellar"
        style={{ y, scale }}
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Subtle vignette for cohesion */}
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(120% 90% at 50% 50%, transparent 55%, rgba(0,0,0,0.6) 100%)" }}
      />

      {/* Hairline frame */}
      <div className="absolute inset-0 border-y" style={{ borderColor: "var(--hairline)" }} />
    </section>
  );
}
